import { DeleteOutlined } from '@ant-design/icons';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ListMenu from "..";
import { useEffectSuccess } from '../../Providers/helpers/useCompare';
import DeleteBankFeedTransactionModal from './DeleteBankFeedTransactionModal';

export default function BankFeedTransactionListMenu({record, currency_symbol}) {
    useLingui();

    const deleteState = useSelector(state => state.BankFeed.bankFeedTransactionDeleteState);

    const [isModalVisible, setIsModalVisible] = useState(false);

    const onModalCancel = () => setIsModalVisible(false);
    useEffectSuccess(deleteState, () => setIsModalVisible(false));

    const getItems = () => {
        const items = [];

        items.push({
            key: 'delete',
            label: t`Delete`,
            action: () => setIsModalVisible(true),
            icon: <DeleteOutlined />,
        });

        return items;
    };

    return (
        <>
            <DeleteBankFeedTransactionModal
                open={isModalVisible}
                record={record}
                currency_symbol={currency_symbol}
                onCancel={onModalCancel}
                deleteState={deleteState}
            />
            <ListMenu items={getItems()} />
        </>
    );
}
